import { useEffect, useRef } from 'react';

import { usePdpUBL } from '../../hooks/usePdpUBL';

interface PdpTtiLogProps {
  productId: string;
}

export const PdpTtiLog: React.FC<React.PropsWithChildren<PdpTtiLogProps>> = ({ children, productId }) => {
  const { ttiUBL } = usePdpUBL();
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    // 부분 네이티브화로 인해 TTI 로그는 앱에서 전송, legacy 케이스만 웹뷰에서 전달한다.
    if (!hasLoggedRef.current) {
      ttiUBL(productId);
      hasLoggedRef.current = true;
    }
  }, [productId, ttiUBL]);

  return <>{children}</>;
};
